import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SpinnerService } from "app/services/spinner.service";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { getComponentName } from '../../../../global';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor{
    
    constructor(private spinnerService: SpinnerService){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      
      if (getComponentName() == 'PersonalDetailComponent')
      {
        //Para la pantalla de gestion de personal el spinner se maneja dentro
        return next.handle(req);
      } 
      else
      {
        this.spinnerService.show();
        this.spinnerService.cantidad = this.spinnerService.cantidad + 1;
        
        return next.handle(req).pipe(
          finalize(() =>
          {
            this.spinnerService.cantidad = this.spinnerService.cantidad - 1;
            if (this.spinnerService.cantidad === 0)
            {
              this.spinnerService.hide();
            }
          }));
      }
      
    }

}
